import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "tooltipContent"];
import React from "react";
import ICON_MAPPING from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
var getDefaultTooltipContent = function getDefaultTooltipContent(action) {
  return action.charAt(0).toUpperCase() + action.slice(1);
};
function getIconButtonProps(actionProps, action) {
  var Component = ICON_MAPPING[action];
  var onClick = actionProps.onClick,
    _actionProps$tooltipC = actionProps.tooltipContent,
    tooltipContent = _actionProps$tooltipC === void 0 ? getDefaultTooltipContent(action) : _actionProps$tooltipC,
    restProps = _objectWithoutProperties(actionProps, _excluded);
  return _extends({}, restProps, {
    icon: /*#__PURE__*/_jsx(Component, {}),
    onClick: onClick,
    tooltipContent: tooltipContent
  });
}
export default getIconButtonProps;